// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__Lwmhv","transparent":"overlay_transparent__Q53y0"};